import { Component } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

// Translations
import { TranslateService } from '@ngx-translate/core';
import { L10n, loadCldr, setCulture } from '@syncfusion/ej2-base';

import { DICTIONARY_ES } from 'src/assets/dictionaries/dictionary_es';
import { DICTIONARY_CL } from 'src/assets/dictionaries/dictionary_cl';
import { DICTIONARY_PT } from 'src/assets/dictionaries/dictionary_pt';
import { DICTIONARY_CO } from 'src/assets/dictionaries/dictionary_co';
import { DICTIONARY_AR } from 'src/assets/dictionaries/dictionary_ar';
import { DICTIONARY_EN } from 'src/assets/dictionaries/dictionary_en';
import { DICTIONARY_CAT } from 'src/assets/dictionaries/dictionary_cat';
// ES
import * as cagregorian_es from 'node_modules/cldr-data/main/es/ca-gregorian.json';
import * as numbers_es from 'cldr-data/main/es/numbers.json';
import * as timeZoneNames_es from 'cldr-data/main/es/timeZoneNames.json';
// CL
import * as cagregorian_cl from 'cldr-data/main/es-CL/ca-gregorian.json';
import * as numbers_cl from 'cldr-data/main/es-CL/numbers.json';
import * as timeZoneNames_cl from 'cldr-data/main/es-CL/timeZoneNames.json';
// CO
import * as cagregorian_co from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers_co from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames_co from 'cldr-data/main/es-CO/timeZoneNames.json';
// MX
import * as cagregorian_mx from 'cldr-data/main/es-MX/ca-gregorian.json';
import * as numbers_mx from 'cldr-data/main/es-MX/numbers.json';
import * as timeZoneNames_mx from 'cldr-data/main/es-MX/timeZoneNames.json';
// PE
import * as cagregorian_pe from 'cldr-data/main/es-PE/ca-gregorian.json';
import * as numbers_pe from 'cldr-data/main/es-PE/numbers.json';
import * as timeZoneNames_pe from 'cldr-data/main/es-PE/timeZoneNames.json';
// PT
import * as cagregorian_pt from 'cldr-data/main/pt/ca-gregorian.json';
import * as numbers_pt from 'cldr-data/main/pt/numbers.json';
import * as timeZoneNames_pt from 'cldr-data/main/pt/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
// AR
import * as cagregorian_ar from 'cldr-data/main/es-AR/ca-gregorian.json';
import * as numbers_ar from 'cldr-data/main/es-AR/numbers.json';
import * as timeZoneNames_ar from 'cldr-data/main/es-AR/timeZoneNames.json';
// EN
import * as cagregorian_en from 'cldr-data/main/en/ca-gregorian.json';
import * as numbers_en from 'cldr-data/main/en/numbers.json';
import * as timeZoneNames_en from 'cldr-data/main/en/timeZoneNames.json';
/*// CAT
import * as cagregorian_cat from 'cldr-data/main/cat/ca-gregorian.json';
import * as numbers_cat from 'cldr-data/main/cat/numbers.json';
import * as timeZoneNames_cat from 'cldr-data/main/cat/timeZoneNames.json';*/

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Qsigner-frontend';
  pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  private navigatorLang: string = 'es-ES';

  constructor(public sessionStorage: LocalStorageService, private translateService: TranslateService) {
    // Vaciar por completo la caché.
    this.sessionStorage.clear();
    // Change test language.
    if (sessionStorage.retrieve('language')) {
      let newLanguage = sessionStorage.retrieve('language');
      let user = sessionStorage.retrieve('STORAGE_USER');
      user['user'][0]['language'] = newLanguage;
      sessionStorage.store('STORAGE_USER', user);
    }
    // Set application language
    this.setAppLanguage();
  }

  // Set application language
  public setAppLanguage(): void {
    // Check user language (session)
    const sessionStorage = this.sessionStorage.retrieve('STORAGE_USER');
    let language;
    if (sessionStorage) {
      language = this.sessionStorage.retrieve('STORAGE_USER')['user'][0]['language'];
    }
    // Assign language only if session and sessionLanguage
    if (!language) {
      // Default language, using locale
      this.navigatorLang = navigator.language;
      switch (this.navigatorLang) {
        case 'es-AR':
          language = 'ar';
          break;
        case 'es-BO':
          language = 'es'; // TODO change when BO is available
          break;
        case 'es-CL':
          language = 'cl';
          break;
        case 'es-CO':
          language = 'co';
          break;
        case 'es-ES':
          language = 'es';
          break;
        case 'es-MX':
          language = 'mx';
          break;
        case 'es-PE':
          language = 'pe';
          break;
        case 'pt-PT':
          language = 'pt';
          break;
        case 'en-US':
          language = 'en';
          break;
        default:
          language = 'es';
          break;
      }
    }
    // Set spanish as default language
    console.log('[Language] Set to', language);
    this.translateService.use(language);
    switch (language) {
      case 'ar':
        loadCldr(cagregorian_ar, numbers_ar, timeZoneNames_ar, numberingSystems);
        L10n.load({ ar: DICTIONARY_AR });
        setCulture('es');
        break;
      case 'es':
        loadCldr(cagregorian_es, numbers_es, timeZoneNames_es, numberingSystems);
        L10n.load({ es: DICTIONARY_ES });
        setCulture('es');
        break;
      case 'cl':
        loadCldr(cagregorian_cl, numbers_cl, timeZoneNames_cl, numberingSystems);
        L10n.load({ cl: DICTIONARY_CL });
        setCulture('es');
        break;
      case 'co':
        loadCldr(cagregorian_co, numbers_co, timeZoneNames_co, numberingSystems);
        L10n.load({ co: DICTIONARY_CO });
        setCulture('es');
        break;
      case 'mx':
        loadCldr(cagregorian_mx, numbers_mx, timeZoneNames_mx, numberingSystems);
        L10n.load({ es: DICTIONARY_ES });
        setCulture('es');
        break;
      case 'pe':
        loadCldr(cagregorian_pe, numbers_pe, timeZoneNames_pe, numberingSystems);
        L10n.load({ es: DICTIONARY_ES });
        setCulture('es');
        break;
      case 'pt':
        loadCldr(cagregorian_pt, numbers_pt, timeZoneNames_pt, numberingSystems);
        L10n.load({ pt: DICTIONARY_PT });
        setCulture('pt');
        break;
      case 'en':
        loadCldr(cagregorian_en, numbers_en, timeZoneNames_en, numberingSystems);
        L10n.load({ en: DICTIONARY_EN });
        setCulture('en');
        break;
      default:
        loadCldr(cagregorian_es, numbers_es, timeZoneNames_es, numberingSystems);
        L10n.load({ es: DICTIONARY_ES });
        setCulture('es');
        this.translateService.use('es');
        break;
    }
  }
}
